import { call, select } from 'redux-saga/effects';
import { selectDeviceType } from 'features/application/applicationSlice';
import { signalingPinnedPanelsChanged } from 'features/side-panels/sidePanelsSlice';
import { isMobileViewport } from './isMobileViewport';
import { applyRemotePinnedPanelsSaga } from './applyRemotePinnedPanelsSaga';

export function* onPinnedPanelsChangedSaga(
  action: ReturnType<typeof signalingPinnedPanelsChanged>
) {
  const deviceType: string = yield select(selectDeviceType);
  const isMobile: boolean = yield call(isMobileViewport, deviceType);

  if (isMobile) {
    return;
  }

  yield call(applyRemotePinnedPanelsSaga, action.payload.panels);
}
